/*
 * @Author       : LiYang
 * @Date         : 2021-08-27 17:34:34
 * @LastEditTime : 2021-12-23 21:08:58
 * @LastEditors  : Please set LastEditors
 * @Description  : 把函数转成成promise
 */

export default (puppet) => {
  return new Promise((resolve, reject) => {
    puppet(resolve, reject)
  })
}
